import React from 'react';
import { Col, Form, Row, Typography, Select, Checkbox } from 'antd';
import uuid from 'react-uuid';
import { useTranslation } from 'react-i18next';
import Helpers from 'helpers';

const { Option, OptGroup } = Select;

const renderShopOptions = (shops = []) =>
  shops.map(({ title, value }) => (
    <Option key={uuid()} value={value}>
      {title}
    </Option>
  ));

const ShopSection = ({
  shoppingCenters,
  companyCategories,
  shops = [],
  inactiveShops = [],
  isShoppingCenter,
  isView,
}) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Stores')}</Typography.Title>
      </Col>
      {isShoppingCenter && (
        <>
          <Col span={6}>
            <Form.Item label={t('Village')} name='shopping_center_id'>
              <Select disabled={isView} placeholder={t('Village')}>
                <Option value=''>{t('Selezioni opzione')}</Option>
                {shoppingCenters.map(({ title, value }) => (
                  <Option key={uuid()} value={value}>
                    {title}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col offset={6} span={18}>
            <Form.Item label={t('CATEGORIE')} name='company_category_ids'>
              <Checkbox.Group disabled={isView}>
                {companyCategories.map((i) => (
                  <Row key={uuid()}>
                    <Col>
                      <Checkbox value={i.value}>{i.title}</Checkbox>
                    </Col>
                  </Row>
                ))}
              </Checkbox.Group>
            </Form.Item>
          </Col>
        </>
      )}
      {!isShoppingCenter && (
        <Col span={6}>
          <Form.Item label={t('Insegna')} name='company_id'>
            <Select
              disabled={isView}
              {...Helpers.addSearchProps()}
              placeholder={t('Insegna')}
            >
              <Option value=''>{t('Selezioni opzione')}</Option>
              {inactiveShops.length ? (
                <>
                  <OptGroup key='active' label={t('Insegne attive')}>
                    {renderShopOptions(shops)}
                  </OptGroup>
                  <OptGroup key='inactive' label={t('Insegne non attive')}>
                    {renderShopOptions(inactiveShops)}
                  </OptGroup>
                </>
              ) : (
                renderShopOptions(shops)
              )}
            </Select>
          </Form.Item>
        </Col>
      )}
    </Row>
  );
};

export default React.memo(ShopSection);
